import React from 'react';

function ErrorIconBlack() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9999 27.4749C21.8897 27.4749 27.4749 21.8897 27.4749 14.9999C27.4749 8.11015 21.8897 2.5249 14.9999 2.5249C8.11015 2.5249 2.5249 8.11015 2.5249 14.9999C2.5249 21.8897 8.11015 27.4749 14.9999 27.4749ZM14.0999 8.9999V16.4999C14.0999 16.997 14.5028 17.3999 14.9999 17.3999C15.497 17.3999 15.8999 16.997 15.8999 16.4999V8.9999C15.8999 8.50285 15.497 8.0999 14.9999 8.0999C14.5028 8.0999 14.0999 8.50285 14.0999 8.9999ZM16.0499 20.5499C16.0499 21.1298 15.5798 21.5999 14.9999 21.5999C14.42 21.5999 13.9499 21.1298 13.9499 20.5499C13.9499 19.97 14.42 19.4999 14.9999 19.4999C15.5798 19.4999 16.0499 19.97 16.0499 20.5499Z"
        fill="#08081B"
      />
      <mask
        id="mask0_1507_21982"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="26"
        height="26"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9999 27.4749C21.8897 27.4749 27.4749 21.8897 27.4749 14.9999C27.4749 8.11015 21.8897 2.5249 14.9999 2.5249C8.11015 2.5249 2.5249 8.11015 2.5249 14.9999C2.5249 21.8897 8.11015 27.4749 14.9999 27.4749ZM14.0999 8.9999V16.4999C14.0999 16.997 14.5028 17.3999 14.9999 17.3999C15.497 17.3999 15.8999 16.997 15.8999 16.4999V8.9999C15.8999 8.50285 15.497 8.0999 14.9999 8.0999C14.5028 8.0999 14.0999 8.50285 14.0999 8.9999ZM16.0499 20.5499C16.0499 21.1298 15.5798 21.5999 14.9999 21.5999C14.42 21.5999 13.9499 21.1298 13.9499 20.5499C13.9499 19.97 14.42 19.4999 14.9999 19.4999C15.5798 19.4999 16.0499 19.97 16.0499 20.5499Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1507_21982)">
        <rect width="30" height="30" fill="#08081B" />
      </g>
    </svg>
  );
}

export default ErrorIconBlack;
